import _ from "lodash";

export function getComparator(order, orderBy, ignoredValues = []) {
  function naComparator(a, b, ignoredValues) {
    const aVal = _.get(a, orderBy);
    const bVal = _.get(b, orderBy);
    const aNA = ignoredValues.includes(aVal);
    const bNA = ignoredValues.includes(bVal);
    if (aNA && bNA) return 0;
    if (aNA) return 1;
    if (bNA) return -1;
    return 0;
  }
  function descendingComparator(a, b, orderBy) {
    const aVal = _.get(a, orderBy);
    const bVal = _.get(b, orderBy);
    if (bVal < aVal) return -1;
    if (bVal > aVal) return 1;
    return 0;
  }

  return order === "desc"
    ? (a, b) => naComparator(a, b, ignoredValues) || descendingComparator(a, b, orderBy)
    : (a, b) => naComparator(a, b, ignoredValues) || -descendingComparator(a, b, orderBy);
}


export function stableSort(array, comparator) {
  const stabilizedThis = array.map((element, index) => [element, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((element) => element[0]);
}
